import { StorageProvider, StorageProviderWithAuth } from "@dashboard-v3/api";
import { toStorageType } from "@dashboard-v3/shared";

const storageProviders: StorageProviderWithAuth[] = [
  "BOX",
  "GOOGLEDRIVE",
  "ONEDRIVE",
  "EGNYTE",
  "DROPBOX",
  "EGNYTE_GOV",
];

export default storageProviders;

export { toStorageType };

export const matchesStorageType = (a: StorageProvider, b: StorageProvider) =>
  toStorageType(a) === toStorageType(b);

export type StorageType = Exclude<StorageProviderWithAuth, "EGNYTE_GOV">;

/** The providers that are an actual storage type, so a valid value to persist. */
export const storageTypes = storageProviders.filter(
  (provider): provider is StorageType => provider !== "EGNYTE_GOV"
);
